import {
  ArrayField,
  ReferenceField,
  SimpleShowLayout,
  TextField,
  useRecordContext,
  WithListContext,
} from "react-admin";

import { administrationRequests } from "api/administrationApi";
import { settings } from "app";
import { Grid, useMediaQuery } from "@mui/material";
import { SectionTitle } from "features/SectionTitle";
import SlotInfo from "./SlotInfo";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import GradesAndStatusModal from "./GradesAndStatusModal";

const ExamContent = ({ exam, index, campaignId }) => {
  const slot = exam.slot;

  const isExamPast = exam.slot?.date
    ? new Date(exam.slot.date).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)
    : false;

  return (
    <>
      <Grid
        item
        xs={12}
        sx={{ display: "flex", gap: 8 }}
      >
        <ReferenceField
          key={index}
          record={{ examId: exam.examId }}
          source="examId"
          reference={administrationRequests.getExamsSelect()}
        >
          <TextField
            source="name"
            color={"#4E2683"}
            sx={{ fontWeight: "bold", fontSize: "14px" }}
          />
        </ReferenceField>
        {slot && isExamPast ? (
          <SecuredComponent
            permission={permissions.canPreviewSpecialistsCampaignExamResults}
            label="Редакция на оценка"
          >
            <GradesAndStatusModal
              campaignId={campaignId}
              examId={exam.examId}
            />
          </SecuredComponent>
        ) : null}
      </Grid>
      {slot ? <SlotInfo slot={slot} /> : null}
    </>
  );
};
const ExamsSection = () => {
  const record = useRecordContext();
  const campaignId = record?.id;
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));

  return (
    <SimpleShowLayout>
      <Grid
        container
        spacing={2}
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        <Grid
          item
          xs={12}
        >
          <SectionTitle
            title="Изпити"
            paddingY={0}
          />
        </Grid>
        <Grid
          item
          xs={12}
        >
          <ArrayField
            source="exams"
            label={""}
          >
            <WithListContext
              render={({ data }) =>
                data.map((exam, index) => {
                  return (
                    <ExamContent
                      key={`ExamContent-${index}`}
                      index={index}
                      exam={exam}
                      campaignId={campaignId}
                    />
                  );
                })
              }
            />
          </ArrayField>
        </Grid>
      </Grid>
    </SimpleShowLayout>
  );
};
export default ExamsSection;
